/*
 * AgentServiceBase + DummyAgentService.
 *
 * Ersetzt das fruehere ChatService.js. Die CoreConsole haelt eine Instanz
 * davon (Feldname: `agentService`) und ruft initialize/send/sendStreaming/
 * switchProject/abort/destroy auf — dieselbe Drop-In-API wie der alte Chat.
 *
 * `AgentService` (separater File) ist die Real-Implementation, die einen
 * RealAgentTransport haelt und cursorContext + reviewResults vor jedem
 * sendStreaming aus dem Editor + ReviewController einsammelt.
 */

export class AgentServiceBase {
    async initialize() {
        return null
    }

    async send(_message) {
        throw new Error('AgentServiceBase.send() must be implemented')
    }

    async sendStreaming(_message, _callbacks) {
        const response = await this.send(_message)
        if (_callbacks?.onDelta) _callbacks.onDelta(response.text)
        if (_callbacks?.onDone) _callbacks.onDone({})
    }

    async switchProject(_projectId) {}

    abort() {}

    destroy() {}
}

/**
 * Fallback wenn der Server nicht erreichbar ist (initialize wirft).
 */
export class DummyAgentService extends AgentServiceBase {
    async initialize() {
        return {
            text: 'Carbisdale Core initialized. AI services not available.',
            type: 'SYSTEM'
        }
    }

    async send(_message) {
        return {
            text: 'Sorry, Carbisdale Core Logic offline, please try again later.',
            type: 'AI'
        }
    }
}
